import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Tooltip from '@material-ui/core/Tooltip';
import classNames from 'classnames';

import { translate } from 'services/i18nService';
import ModalService from 'services/ModalService';
import ChatStore from 'stores/ChatStore';
import FirebaseStore from 'stores/FirebaseStore';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import allUserGroups from 'enum/userGroups';
import { TabPanelType } from 'utils/consts';
import { isMyProfileHelperFunc } from 'utils/helpers';

import crownImageUrl from '../../../images/performerVideo/leader-crown.png';

import styles from './TipLeaderChat.css';


const TipLeaderChat = (props) => {
  const { showBuyTokensModal, roomName, user, topTipper, isBroadcasterChat, topTipperAmount } = props;
  const { setActiveConversation } = ChatStore;
  const { profileName } = ProfileStore;
  const { webUsers } = FirebaseStore;
  const { hasCF } = UserStore;

  const broadcasterAsViewer = hasCF(allUserGroups.BROADCASTER_AS_VIEWER) && isMyProfileHelperFunc(user, profileName);
  const isBroadcasterChatOrBroadcasterAsViewer =
    isBroadcasterChat || broadcasterAsViewer;
  const isLoggedInUserTopTipper = topTipper.toLowerCase() === user.username && user.username.toLowerCase();
  const isAnonymous = topTipper.toLowerCase() === '.';
  const openBeatLeaderModal = () => {
    ModalService.showModal(ModalService.MODAL_KEYS.BEAT_THE_LEADER, {
      close: ModalService.hideModal,
      show: true,
      showBuyTokensModal,
      roomName,
      user,
    });
  };

  const tipLeaderButton = classNames({
    [styles.tipLeaderButton]: true,
    [styles.tipLeaderButtonBroadcaster]: broadcasterAsViewer,
  });

  const handleBroadcasterTopTipperConversation = useCallback(() => {
    if (!isAnonymous) {
      const onlineTopTipperName = Object.keys(webUsers).find((tipper) => tipper.toLowerCase() === topTipper);
      if (onlineTopTipperName) {
        ChatStore.setBroadcasterChatTab(TabPanelType.privateChat);
        setActiveConversation(onlineTopTipperName);
      } else {
        ModalService.showModal(ModalService.MODAL_KEYS.PRIVATE_MESSAGE_MODAL, { receiverUsername: topTipper });
      }
    }
  }, [webUsers, isAnonymous, topTipper, setActiveConversation]);

  return (
    <div
      className={tipLeaderButton}
      id="TipLeaderChatButton"
      role="presentation"
      onClick={isBroadcasterChat ? handleBroadcasterTopTipperConversation : openBeatLeaderModal}
    >
      {isBroadcasterChatOrBroadcasterAsViewer ? (
        <Tooltip arrow={true} title={`${translate('v2broadcast.tip.leader.tips')}: ${topTipperAmount}`}>
          <span className={styles.elementWrapper}>
            <img alt="crown" className={styles.crownImage} src={crownImageUrl} />
            <div className={styles.leaderText}>
              {isAnonymous && translate('v2profile.anonymous.tip.leader')}
              {!isAnonymous && translate('strings.ChatSettings.toptipper', { 0: topTipper })}
            </div>
          </span>
        </Tooltip>
      ) : (
        <span className={styles.elementWrapper}>
          <img alt="crown" className={styles.crownImage} src={crownImageUrl} />
          <div className={styles.leaderText}>
            {isLoggedInUserTopTipper && !isAnonymous && translate('v2profile.you.are.tip.leader')}
            {isLoggedInUserTopTipper && isAnonymous && translate('v2profile.anonymous.tip.leader')}
            {!isLoggedInUserTopTipper && !isAnonymous && translate('strings.ChatSettings.toptipper', { 0: topTipper })}
            {!isLoggedInUserTopTipper && isAnonymous && translate('v2profile.anonymous.tip.leader')}
          </div>
        </span>
      )}
    </div>
  );
};

TipLeaderChat.propTypes = {
  roomName: PropTypes.string.isRequired,
  showBuyTokensModal: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).isRequired,
  topTipper: PropTypes.string.isRequired,
  isBroadcasterChat: PropTypes.bool,
  topTipperAmount: PropTypes.number,
  user: PropTypes.object,
};

TipLeaderChat.defaultProps = {
  isBroadcasterChat: false,
  topTipperAmount: 0,
  user: {},
};

export default observer(TipLeaderChat);
